'use strict';

import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';
import loaderStore from '../navigation/loader.store';


let inner,
    items,
    hover,
    width = 0,
    itemsParams = [],
    defaultParams = [0, 0],
    active = 0,
    disable = false;



function _handleResize(e) {
  if (e.width < 1100) {
    disable = true;
    return
  }

  const innerBounds = inner.getBoundingClientRect();

  width = 0;
  itemsParams = [];

  for (let i = 0; items.length > i; i++) {
    const bounds = items[i].getBoundingClientRect();

    itemsParams.push([bounds.left - innerBounds.left, bounds.width]);

    width = Math.max(width, bounds.width);
  }

  hover.style.width = width + 'px';

  setStyle(itemsParams[active]);

  disable = false;
}


function setStyle(params = defaultParams) {
  hover.style.transform = `translate3d(${params[0]}px, 0, 0) scale(${params[1] / width}, 1)`;
}



function init() {
  inner = document.querySelector('.nav-inner');

  if (!inner) return;

  items = inner.querySelectorAll('a');

  if (!items.length) return;

  hover = document.createElement('div');
  hover.classList.add('nav-hover');

  inner.appendChild(hover);

  _handleResize(resizeStore.getData());

  for (let i = 0; items.length > i; i++) {
    const item = items[i];
    if (item.classList.contains('active')) active = i;

    item.addEventListener('mouseover', () => setStyle(itemsParams[i]));

    item.addEventListener('mouseleave', () => setStyle(itemsParams[active]));

    item.addEventListener('click', () => active = i);
  }

  dispatcher.subscribe((e) => {
    if (e.type === 'mutate') {
      for (let i = 0; items.length > i; i++) {
        if (items[i].href === window.location.href) {
          active = i;
          setStyle(itemsParams[i]);
          break;
        }
      }
    }
  });

  resizeStore.eventEmitter.subscribe(_handleResize);
}




export default {
  init: init
}